import { CONFIG } from '../../../config'

const { ENVIROMENT } = CONFIG
const BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/registration`

// Clientes
export function urlGetClients(tpId, allowedTps) {
  return `${BASE_URL}/clients?tp_filter=${tpId}&allowedTps=${allowedTps}`
}

export function urlGetClientsByFleetId(fleetId) {
  return `${BASE_URL}/clients-by-fleet/${fleetId}`
}

export function urlRegisterClient(tpId) {
  return `${BASE_URL}/client/${tpId}`
}

export function urlRegisterClient2() {
  return `${BASE_URL}/clientV2/v2`
}

export function urlUpdateClient(clientId) {
  return `${BASE_URL}/client/${clientId}`
}

export function urlRegisterClientAndAssocCompany(tpId, cycle_id) {
  return `${BASE_URL}/client/${tpId}/${cycle_id}`
}

export function urlGetClientByCnpj(cnpj) {
  return `${BASE_URL}/client-by-cnpj/${cnpj}`
}

export function urlGetClientByDeliveryId(deliveryId) {
  return `${BASE_URL}/client-by-delivery/${deliveryId}`
}

export function urlPostSendRetriePasswordEmail(user_email) {
  return `${BASE_URL}/recuperar-senha/${user_email}`
}

export function urlPostChangePassword(token) {
  return `${BASE_URL}/alterar-senha/${token}`
}

// Cliente x TPs
export const urlPostClientTpAssociation = `${BASE_URL}/client-tp`

export function urlGetClientTpAssociation(clientId, tps) {
  return `${BASE_URL}/client-tps/?client_id=${clientId}&allowedTps=${tps}`
}

// Cliente x Empresas
export const urlPostClientCompanyAssociation = `${BASE_URL}/client-company`

export function urlGetClientCompanyAssociation(clientId, empresas) {
  return `${BASE_URL}/client-companies/?client_id=${clientId}&allowedCompanies=${empresas}`
}

// Cliente x Trechos
export function urlGetTrechos(clientId, centraloperacoes_id) {
  return `${BASE_URL}/client-steps/${centraloperacoes_id}/${clientId}`
}

export const urlPostTrecho = `${BASE_URL}/client-steps`

export const urlPostClientesSemTrecho = `${BASE_URL}/clientes-sem-trecho`

export function urlDeleteTrecho(trecho_id, centraloperacoes_id) {
  return `${BASE_URL}/client-step/${centraloperacoes_id}/${trecho_id}`
}

// Produtos
export function urlGetProdutos(empresaId) {
  return `${BASE_URL}/products/${empresaId}`
}

export function urlGetProductsByCompanyIdAndEan(empresaId, codigoBarras) {
  return `${BASE_URL}/products/${empresaId}/${codigoBarras}`
}

export function urlGetProdutosWithEanOnExcel(empresaId) {
  return `${BASE_URL}/products/export/${empresaId}?t=${localStorage.getItem('t')}`
}

export function urlGetProdutosSemEanOnExcel(empresaId) {
  return `${BASE_URL}/products/export/${empresaId}?semEan=1&t=${localStorage.getItem('t')}`
}

export function urlReportCodigoBarrasProdutos(empresaId, tipo) {
  const tipoParam = tipo || 'product_code'
  return `${BASE_URL}/products/codigo-barras/${empresaId}?tipo=${tipoParam}&t=${localStorage.getItem('t')}`
}

export const urlSalvarProduto = `${BASE_URL}/product`

export const urlSalvarProdutoComEan = `${BASE_URL}/product-com-ean`

// Eans
export function urlGetEans(produtoId) {
  return `${BASE_URL}/eans/${produtoId}`
}

export function urlSalvarEan(produtoId) {
  return `${BASE_URL}/ean/${produtoId}`
}

export function urlCodigoBarrasEans(eans) {
  return `${BASE_URL}/eans/codigo-barras?eans=${eans}&t=${localStorage.getItem('t')}`
}

export function urlDeleteEan(eanId) {
  return `${BASE_URL}/ean/${eanId}`
}

export function urlGetDesdobramento(produtoOrigemId) {
  return `${BASE_URL}/desdobramento-produto/${produtoOrigemId}`
}

export function urlGetPosicoesEstoquePadraoProduto(produtoId, tpId) {
  return `${BASE_URL}/product/${produtoId}/posicoes-estoque-padrao/${tpId}`
}

export function urlDeletePosicaoEstoquePadraoProduto(produtoId, tpId, id) {
  return `${BASE_URL}/product/${produtoId}/posicoes-estoque-padrao/${tpId}/${id}`
}

export function urlGetProdutoDePara(produtoParaId) {
  return `${BASE_URL}/product/${produtoParaId}/de-para`
}

export function urlDeleteProdutoDePara(produtoParaId, id) {
  return `${BASE_URL}/product/${produtoParaId}/de-para/${id}`
}

//Motoristas
export const urlPostMotorista = `${BASE_URL}/vehicle-driver`

export function urlGetMotoristas(tp_id) {
  return `${BASE_URL}/vehicle-drivers/${tp_id}`
}

//Ajudantes
export const urlPostAjudante = `${BASE_URL}/driver-assistant`

export function urlGetAjudantes(tp_id) {
  return `${BASE_URL}/driver-assistants/${tp_id}`
}

export function urlGetAjudantesAtivos(tp_id) {
  return `${BASE_URL}/driver-assistants-active/${tp_id}`
}

// Veiculos
export function urlGetVeiculoInfoIniciais(tp_id) {
  return `${BASE_URL}/vehicle-init-info/${tp_id}`
}

export function urlGetVeiculos(tp_id) {
  return `${BASE_URL}/vehicles/${tp_id}`
}

export function urlTagVeiculos(params) {
  return `${BASE_URL}/tags-vehicles?vehicles_id=${params}&t=${localStorage.getItem('t')}`
}

export const urlPostVeiculo = `${BASE_URL}/vehicle`

// Rota de Entrega
export function urlGetRotasDeEntrega(tp_id) {
  return `${BASE_URL}/rota-entrega/${tp_id}`
}

export function urlGetAssocRotaEntregaCliente(tp_id, cliente_id) {
  return `${BASE_URL}/assoc-rota-entrega-cliente/${tp_id}/${cliente_id}`
}

export function urlPostAssocRotaEntregaCliente() {
  return `${BASE_URL}/assoc-rota-entrega-cliente`
}

export function urlSearchClientsByCnpjOrName(term, tpId) {
  return `${BASE_URL}/pesquisar-clientes-by?term=${term}&tp_id=${tpId}`
}

// Transportadoras
export function urlGetTransportadoras(tp_id) {
  return `${BASE_URL}/transportadora/${tp_id}`
}

export function urlSaveTransportadora(tp_id) {
  return `${BASE_URL}/transportadora/${tp_id}`
}

export function urlUpdateTransportadora() {
  return `${BASE_URL}/update/transportadora`
}

export function urlDeleteTransportadora(tpId, id) {
  return `${BASE_URL}/delete/transportadora/${tpId}/${id}`
}

// Veiculos Transferencia
export function urlGetVehiclesTransfer(tp_id) {
  return `${BASE_URL}/vehicle-transfer/${tp_id}`
}

export function urlSaveVehicleTransfer(tp_id) {
  return `${BASE_URL}/vehicle-transfer/${tp_id}`
}

export function urlUpdateVehicleTransfer() {
  return `${BASE_URL}/update/vehicle-transfer`
}

export function urlDeleteVehicleTransfer(tpId, id) {
  return `${BASE_URL}/delete/vehicle-transfer/${tpId}/${id}`
}

// Motivos Atrasos
export function urlGetMotivoAtraso(user_id, tp_id, type) {
  return `${BASE_URL}/motivo-atraso/get/${type}/${user_id}/${tp_id}`
}

export function urlSaveMotivoAtraso(user_id) {
  return `${BASE_URL}/motivo-atraso/create/${user_id}`
}

export function urlUpdateMotivoAtraso(user_id) {
  return `${BASE_URL}/motivo-atraso/update/${user_id}`
}

export function urlDeleteMotivoAtraso(id) {
  return `${BASE_URL}/motivo-atraso/delete/${id}`
}

// Seguradoras
export const urlPostSeguradora = `${BASE_URL}/seguradora`

export function urlGetSeguradoras(tp_id) {
  return `${BASE_URL}/seguradora/${tp_id}`
}
export const urlPostTipoVeiculo = `${BASE_URL}/vehicle-manufacturer`

export const urlGetTipoVeiculo = `${BASE_URL}/vehicle-manufacturers`

// Regras de Frete
export const urlPostRegrasFrete = `${BASE_URL}/regras-frete`

export function urlGetRegrasFrete(tp_id) {
  return `${BASE_URL}/regras-frete?tp_id=${tp_id}`
}

// Regras de Faturamento
export const urlPostRegrasFaturamento = `${BASE_URL}/regras-faturamento`

export function urlGetRegrasFaturamento(tp_id) {
  return `${BASE_URL}/regras-faturamento?tp_id=${tp_id}`
}

export function urlPutRegrasFaturamento(id) {
  return `${BASE_URL}/regras-faturamento/${id}`
}

// Faixa de KM
export const urlPostFaixaKm = `${BASE_URL}/faixa-km`

export function urlGetFaixaKm(tp_id) {
  return `${BASE_URL}/faixa-km?tp_id=${tp_id}`
}

export function urlPutFaixaKm(id) {
  return `${BASE_URL}/faixa-km/${id}`
}

// Zona de Entrega
export const urlPostZonaEntrega = `${BASE_URL}/zona-entrega`

export function urlGetZonasEntrega(tp_id) {
  return `${BASE_URL}/zona-entrega?tp_id=${tp_id}`
}

export function urlPutZonaEntrega(id) {
  return `${BASE_URL}/zona-entrega/${id}`
}

// Serviços (NFS-e)
export const urlServicosNfse = `${BASE_URL}/servicos-nfse`

export function urlPutServicoNfse(id) {
  return `${BASE_URL}/servicos-nfse/${id}`
}

export const urlCodigosTributacaoNacionalNfse = `${BASE_URL}/servicos-nfse/codigos-tributacao`

export const urlCodigosNbsNfse = `${BASE_URL}/servicos-nfse/nbs`

// Regra de Frete
export const urlPostRegraFrete = `${BASE_URL}/regra-frete`

export function urlGetRegraFrete(tp_id, company_id) {
  return `${BASE_URL}/regra-frete?tp_id=${tp_id}&company_id=${company_id}`
}

export function urlPutRegraFrete(tp_id, company_id) {
  return `${BASE_URL}/regra-frete/${tp_id}/${company_id}`
}

export function urlGetValorFrete(delivery_id) {
  return `${BASE_URL}/regra-frete/valor/${delivery_id}`
}

export const urlPostValorFreteConsolidado = `${BASE_URL}/regra-frete/valor-consolidado`

// Diárias por Veículo
export const urlPostVehiclesDaily = `${BASE_URL}/vehicles-daily`

export function urlGetVehiclesDaily({ tp_id, company_id, manufacturer_id }) {
  let url = `${BASE_URL}/vehicles-daily?tp_id=${tp_id}&company_id=${company_id}`
  if (manufacturer_id) url += `&manufacturer_id=${manufacturer_id}`
  return url
}

export function urlPutVehiclesDaily(id) {
  return `${BASE_URL}/vehicles-daily/${id}`
}

export const urlPostCompaniesImport = `${BASE_URL}/companies-import`

// CNPJs Secundários (por empresa)
export function urlCompanyCnpjs(companyId) {
  return `${BASE_URL}/company/${companyId}/cnpjs`
}
export function urlPostCompanyCnpj(companyId) {
  return `${BASE_URL}/company/${companyId}/cnpj`
}
export function urlDeleteCompanyCnpj(companyId, id) {
  return `${BASE_URL}/company/${companyId}/cnpj/${id}`
}

// SIF Units (por empresa)
export function urlCompanySifUnits(companyId) {
  return `${BASE_URL}/company/${companyId}/sif-units`
}
export function urlPostCompanySifUnit(companyId) {
  return `${BASE_URL}/company/${companyId}/sif-unit`
}
export function urlCompanySifUnitsActived(companyId) {
  return `${BASE_URL}/company/${companyId}/sif-units-actived`
}

export function urlExportarClientesRotasEntrega(tp_id) {
  return `${BASE_URL}/cliente-rotas-entrega-tp/exportar/${tp_id}?t=${localStorage.getItem('t')}`
}

// Analistas de Monitoramento de Entregas
export const urlAnalistasEntrega = `${BASE_URL}/analistas-entrega`
export const urlAnalistasEntregaUsuariosElegiveis = `${BASE_URL}/analistas-entrega/usuarios-elegiveis`
export function urlAnalistasEntregaVeiculos(tp_id) {
  return `${BASE_URL}/analistas-entrega/veiculos/${tp_id}`
}
export const urlAnalistasEntregaVeiculosAssociar = `${BASE_URL}/analistas-entrega/veiculos`
export const urlAnalistasEntregaTodosVeiculos = `${BASE_URL}/analistas-entrega/todos-veiculos`
